import styles from './Header.module.scss';
import { useWhitelabel } from '@xarvio/frontend-core-state/lib/auth/hooks/useWhitelabel/useWhitelabel';
import { Row, RowCell } from '@xarvio/layout';
import { GreyCircleLoader, TextLoader } from '@xarvio/elements';
import { Text } from '@xarvio/corporate-styles';

const NAVIGATION_ITEM_COUNT = 6;
const ACTION_ITEM_COUNT = 4;

export const HeaderLoadingNavigation = () => (
  <>
    {Array.from({ length: NAVIGATION_ITEM_COUNT }, (_, index) => (
      <div className={styles.loadingNavigationItem} key={index}>
        <GreyCircleLoader theme={'dark'} size={24} />
        <Text type={'h6'}>
          <TextLoader width={'4em'} theme={'dark'} />
        </Text>
      </div>
    ))}
  </>
);

export const HeaderLoadingSkeleton = () => {
  const { whitelabelConfig } = useWhitelabel();

  return (
    <header
      className={styles.header}
      style={
        whitelabelConfig?.primaryColor
          ? { backgroundColor: whitelabelConfig.primaryColor }
          : undefined
      }
    >
      <div className={styles.headerLeftWrapper}>
        <div className={styles.headerLeft}>
          <div className={styles.headerLeftPlaceholder}>
            <Row align={'center'} gaps={'narrow'} margin={'no'} minHeight={64}>
              <RowCell>
                <Text type={'h5'}>
                  <TextLoader width={'100%'} theme={'dark'} />
                </Text>
              </RowCell>
              <RowCell auto>
                <GreyCircleLoader theme={'dark'} size={16} />
              </RowCell>
            </Row>
          </div>
        </div>
      </div>
      <div className={styles.headerMiddleWrapper}>
        <div className={styles.headerMiddle}>
          <div className={styles.headerNav}>
            <HeaderLoadingNavigation />
          </div>
        </div>
      </div>
      <div className={styles.headerRightWrapper}>
        <div className={styles.headerRight}>
          <div className={styles.headerNav}>
            {Array.from({ length: ACTION_ITEM_COUNT }, (_, index) => (
              <div className={styles.loadingActionItem} key={index}>
                <GreyCircleLoader theme={'dark'} size={24} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </header>
  );
};
